import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import './fetchingSpinnerWithOverlay.scss';
import { Overlay } from '../Overlay/Overlay';
import { Loader } from 'components/loaders';
function FetchingSpinnerWithOverlay({ size }) {
    return (_jsx(Overlay, { children: _jsx("div", { className: "fetching-spinner-with-overlay-container", children: _jsx(Loader, { size: size }) }) }));
}
FetchingSpinnerWithOverlay.propTypes = {
    size: PropTypes.number,
};
FetchingSpinnerWithOverlay.defaultProps = {
    size: 40,
};
export default FetchingSpinnerWithOverlay;
